import './permissionsForm.scss';
import React, { PropTypes } from 'react';
import _ from 'underscore';
import { Field, reduxForm, formValueSelector, propTypes as reduxFormPropTypes } from 'redux-form';
import { connect } from 'react-redux';
import { InputFieldWithValidation } from '../../common/FormComponents';
import { reliablyHandleAsyncFormSubmit } from '../../common/formUtils';
import FormErrorNotification from '../../common/FormErrorNotification';
import { isUndefinedNullOrEmpty } from '../../../js/utils';
import permissionLevel from '../../../js/permissionLevel';
import { updatePermissions } from '../../../js/actions/permissionsActionCreators';

const validate = (values) => {
    const errors = {};

    if(isUndefinedNullOrEmpty(values.nameOfGroup)) {
        errors.nameOfGroup = 'Specify a group name';
    }

    return errors;
};

const PermissionsFormRadioFields = React.createClass({
    handleOnChange: function (e) {
        this.props.input.onChange(e.target.value);
    },
    render: function() {
        const { input, meta: { touched, error } } = this.props;

        return (
            <div className="fields">
                <div className="field-group">
                    <div>
                        <input id="permissions-everyone" type="radio" name="permission" value={permissionLevel.everyone} onChange={this.handleOnChange} checked={input.value === 'everyone'} />
                    </div>
                    <div>
                        <strong><label htmlFor="permissions-everyone">Everyone</label></strong>
                        <p>Anyone in your organization can use SQL Clone.</p>
                    </div>
                </div>

                <div className="field-group">
                    <div>
                        <input id="permissions-group" type="radio" name="permission" value={permissionLevel.groupBased} onChange={this.handleOnChange} checked={input.value !== 'everyone'} />
                    </div>
                    <div>
                        <strong><label htmlFor="permissions-group">User group</label></strong>
                        <p>Anyone in this user group can use SQL Clone.</p>
                    </div>
                </div>
            </div>
        );
    }
});

const PermissionsForm = React.createClass({
    propTypes: {
        ...reduxFormPropTypes,
        selectedPermissionsLevel: PropTypes.oneOf(_(permissionLevel).values()),
        initialValues: PropTypes.object,
        onCancel: PropTypes.func.isRequired,
        onSuccess: PropTypes.func.isRequired,
        onChangePermissionRequested: PropTypes.func.isRequired
    },
    changePermission: function(data) {
        const { onChangePermissionRequested, onSuccess } = this.props;
        return reliablyHandleAsyncFormSubmit(() => {
            return onChangePermissionRequested({
                permissionLevel: data.levelOfPermission,
                groupName: data.nameOfGroup
            }).then(() => {
                onSuccess();
            });
        });
    },
    render: function() {
        const { selectedPermissionsLevel, handleSubmit, pristine, submitting, error, onCancel } = this.props;
        const isGroupBased = selectedPermissionsLevel === permissionLevel.groupBased;

        return <div className="form-container settings-form-container">
            <form onSubmit={handleSubmit(this.changePermission)} className="updatePermissionsForm">
                <h2>Change your permissions</h2>

                <FormErrorNotification error={error} />

                <div className="control-holder">
                    <Field name="levelOfPermission" component={PermissionsFormRadioFields} />
                </div>

                <div className="control-holder">
                    {isGroupBased && <Field name="nameOfGroup" component={InputFieldWithValidation} />}
                </div>

                <div className="button-holder">
                    <button type="submit" disabled={pristine || submitting} className="button button--primary">
                        Update
                    </button>
                    <button type="button" className="nobutton button--flat-secondary" onClick={onCancel}>
                        Cancel
                    </button>
                </div>
            </form>
        </div>;
    }
});

const formName = 'permissions';
const selector = formValueSelector(formName);

const mapStateToProps = (state) => ({
    selectedPermissionsLevel: selector(state, 'levelOfPermission')
});

const mapDispatchToProps = (dispatch) => ({
    onChangePermissionRequested: (data) => {
        return dispatch(updatePermissions(data));
    }
});

export default reduxForm({
    form: formName,
    validate
})(connect(mapStateToProps, mapDispatchToProps)(PermissionsForm));



// WEBPACK FOOTER //
// ./src/components/settings/PermissionsPage/PermissionsForm.jsx